<template>
  <div
    @click.self="$emit('dismiss')"
    class="bg-gray-900/50 overflow-scroll fixed left-0 right-0 bottom-0 z-[999]"
    :style="{ top: `${topOffset}px` }"
  >
    <DeviceSearchResult
      @result-clicked="$emit('deviceResultClicked', $event)"
      v-for="r of deviceResults"
      :key="r.value._id"
      :row="r"
    ></DeviceSearchResult>
    <PropertySearchResult
      @result-clicked="$emit('propertyResultClicked', $event)"
      v-for="r of propertyResults"
      :key="r.value._id"
      :row="r"
    ></PropertySearchResult>
  </div>
</template>

<script setup lang="ts">
import { DeviceSearchRow, ProgrammedDeviceContext, PropertySearchRow, SearchRowTypes } from 'common';
import { computed } from 'vue';
import DeviceSearchResult from './DeviceSearchResult.vue';
import PropertySearchResult from './PropertySearchResult.vue';
import { formatPredictions } from '@/components/forms/typeahead/type-ahead';

const props = defineProps<{
  searchResults: (DeviceSearchRow | PropertySearchRow)[];
  searchText?: string;
  topOffset: number;
}>();

defineEmits<{
  (e: 'propertyResultClicked', propertyId: string): void;
  (e: 'deviceResultClicked', val: { context?: ProgrammedDeviceContext; deviceId?: number }): void;
  (e: 'dismiss'): void;
}>();

const deviceResults = computed(() =>
  formatPredictions(
    props.searchResults.filter((r) => r.type === SearchRowTypes.DEVICE),
    props.searchText || '',
    { labelKey: 'serialNumber' }
  )
);
const propertyResults = computed(() =>
  formatPredictions(
    props.searchResults.filter((r) => r.type === SearchRowTypes.PROPERTY),
    props.searchText || '',
    { labelKey: 'name', secondaryLabelKey: 'address' }
  )
);
</script>

<style scoped></style>
